<form [formGroup]="myAccountForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-4">

  <div class="pt-1">
    <p class="mb-3.5 flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-[var(--app-text-muted)]">
      <i class="pi pi-user text-[var(--p-primary-500)]" aria-hidden="true"></i>
      Profile Information
    </p>

    <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <div class="flex flex-col gap-px">
        <p-floatlabel
          variant="on"
          floatLabelErrorMessages
          controlName="first_name"
          fieldName="First Name"
        >
          <input
            pInputText
            id="first_name"
            formControlName="first_name"
            autocomplete="given-name"
            class="w-full"
          />
          <label for="first_name">First Name *</label>
        </p-floatlabel>
      </div>

      <div class="flex flex-col gap-px">
        <p-floatlabel
          variant="on"
          floatLabelErrorMessages
          controlName="last_name"
          fieldName="Last Name"
        >
          <input
            pInputText
            id="last_name"
            formControlName="last_name"
            autocomplete="family-name"
            class="w-full"
          />
          <label for="last_name">Last Name *</label>
        </p-floatlabel>
      </div>

      <div class="flex flex-col gap-px sm:col-span-2">
        <p-floatlabel
          variant="on"
          floatLabelErrorMessages
          controlName="email_address"
          fieldName="Email"
        >
          <input
            pInputText
            id="email_address"
            type="email"
            formControlName="email_address"
            autocomplete="email"
            class="w-full"
          />
          <label for="email_address">Email Address *</label>
        </p-floatlabel>
      </div>
    </div>
  </div>

  <div class="border-t border-[var(--app-border)] pt-4">
    <p class="mb-3.5 flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-[var(--app-text-muted)]">
      <i class="pi pi-lock text-[var(--p-primary-500)]" aria-hidden="true"></i>
      Change Password
      <span
        class="ml-0.5 rounded border border-[var(--app-border)] bg-[var(--p-surface-50)] px-1.5 py-px text-[0.625rem] font-medium normal-case tracking-normal text-[var(--app-text-subtle)]"
      >
        optional
      </span>
    </p>

    <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <div class="flex flex-col gap-px">
        <p-floatlabel
          variant="on"
          floatLabelErrorMessages
          controlName="password"
          fieldName="Password"
          [customMessages]="passwordProfilePatternCustomMessages"
        >
          <p-password
            inputId="password"
            formControlName="password"
            toggleMask
            fluid
            autocomplete="new-password"
            [feedback]="false"
            styleClass="w-full"
            (input)="onPasswordChange()"
          >
            <ng-template #footer>
              <app-password-rule-hints listClass="pl-2 my-0 text-sm" />
            </ng-template>
          </p-password>
          <label for="password">New Password</label>
        </p-floatlabel>
      </div>

      <div class="flex flex-col gap-px">
        <p-floatlabel
          variant="on"
          floatLabelErrorMessages
          controlName="confirm_password"
          fieldName="Confirm Password"
          [customMessages]="passwordConfirmCustomMessages"
        >
          <p-password
            inputId="confirm_password"
            formControlName="confirm_password"
            toggleMask
            fluid
            [feedback]="false"
            autocomplete="new-password"
            styleClass="w-full"
          />
          <label for="confirm_password">Confirm Password</label>
        </p-floatlabel>
      </div>
    </div>
  </div>

  <div class="comm-dialog-footer justify-end">
    <p-button type="button" label="CLOSE" icon="pi pi-times" size="small" [text]="true" severity="secondary" (onClick)="onClose()" />
    <p-button type="submit" label="UPDATE ACCOUNT" icon="pi pi-save" size="small" />
  </div>

</form>
